import React from "react";
import axios from "axios";
// import services, { baseUrl } from "./services.jsx";

export default class Api {
  constructor() {
    this.api_token = null;
    this.client = null;
    this.api_url =
      "http://nft-uat.eba-gfbhdz6n.ap-south-1.elasticbeanstalk.com/";
  }
  init = () => {
    //this.api_token = getCookie("ACCESS_TOKEN");
    let headers = {
      Accept: "application/json",
    };
    if (this.api_token) {
      headers.Authorization = `Bearer ${this.api_token}`;
    }
    this.client = axios.create({
      baseURL: this.api_url,
      timeout: 31000,
      headers: headers,
    });
    return this.client;
  };

  get = (Url, params) => {
    return this.init().get(Url, { params: params });
  };

  post = (Url, obj) => {
    return this.init().post(Url, obj);
  };

  startLoader(){
    return <img src="../Loader/redshilliz-loader.gif" alt="RedShilliz" />
  }
}
